import { Avatar, Link, Stack, Typography } from '@mui/material';
import { ArrowBackBlue, PurpleAlert } from 'Images';
import { useNavigate } from 'react-router-dom';

interface IRedirectNote {
  infoDescription?: string;
  infoLinkText?: string;
  infoLink?: string;
}

export const RedirectNote = ({
  infoDescription,
  infoLinkText,
  infoLink,
}: IRedirectNote) => {
  const navigate = useNavigate();

  if (!infoDescription || !infoLinkText || !infoLink) return null;

  return (
    <Stack
      direction='row'
      gap='10px'
      sx={{
        mt: '20px',
        p: '20px',
        bgcolor: '#E7EDFF',
        border: '1px solid #B7CCFF',
        borderRadius: '12px',
      }}
    >
      <Avatar alt='' src={PurpleAlert} sx={{ width: '24px', height: '24px' }} />
      <Typography variant='body6'>
        {infoDescription}{' '}
        <Link
          variant='body5'
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            width: 'fit-content',
          }}
          tabIndex={0}
          onClick={() => navigate(infoLink)}
        >
          <Typography variant='body5'>{infoLinkText}</Typography>
          <Avatar
            alt=''
            src={ArrowBackBlue}
            sx={{ width: '15px', height: '15px' }}
          />
        </Link>
      </Typography>
    </Stack>
  );
};
